// The UI language is the user's choice and never comes from the browser (BRA-1045). The browser
// only says which region of that language they read: an English UI in an en-GB browser formats
// "29 Dec 2025, 15:00", as luxon did before dates followed the UI language. A UI locale that
// already names a region, or the en-XA pseudo-locale, is used as it is.
export function formattingLocale(uiLocale: string, browserLanguages: readonly string[] = globalThis.navigator?.languages ?? []): string {
    if (uiLocale.includes("-")) {
        return uiLocale;
    }
    const match = browserLanguages.find((tag) => tag.split("-")[0].toLowerCase() === uiLocale.toLowerCase());
    if (!match) {
        return uiLocale;
    }
    try {
        return Intl.getCanonicalLocales(match)[0] ?? uiLocale;
    } catch {
        return uiLocale;
    }
}
